<template>
  <v-card outlined class="py-3 px-5 w-100">
    <table class="w-100">
      <tr class="no-row-border">
        <td class="no-border diagonal-title" style="width: 170px">
          {{ title }}
        </td>
        <td class="table-title" v-for="title in titles" :key="title">
          {{ $t(`balanceResult.${title}`) }}
        </td>
      </tr>
      <tr>
        <td class="table-title no-col-border">Value (Gcal/t)</td>
        <td v-for="value in values" :key="value">
          {{ value }}
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
export default {
  name: "OtherResult",

  props: {
    title: { type: String, required: true },
    tableData: { type: Object, required: true },
  },

  computed: {
    titles() {
      return Object.keys(this.tableData);
    },
    values() {
      return Object.values(this.tableData);
    },
  },
};
</script>
